import { create } from 'zustand'
import axios from 'axios'

interface InventoryStore  {
  selected: any
  data: any[]
  loading: boolean
  error?: any
  getOne: (uuid: string) => Promise<{ success: boolean; data: any }>
  setSelected: (selected: any) => void
}

export const API_SLUG = 'inventory'



export const useInventoryStore = create<InventoryStore>(set => ({
  data: [],
  selected: null,
  loading: false,
  error: undefined,
  setLoading: (loading: boolean) => {
    set({ loading })
  },
  setError: (error: any) => {
    set({ error })
  },
  setSelected: (selected: any) => {
    set({ selected })
  },
  
  getOne: async uuid => {
    set({ loading: true })

    return axios
      .get(`/${API_SLUG}/${uuid}`)
      .then(res => {
        set({ selected: res.data })
        set({ loading: false })

        return { success: true, data: res.data }
      })
      .catch(err => {
        set({ loading: false })
        set({ error: err?.response?.data?.message?.toString() })
        return { success: false, data: err?.response?.data?.message?.toString() }
      })
  },

  clearState: () => {
    set({
      data: [],
      loading: false,
      error: undefined,
      selected: null,
    })
  },
}))
